const PLAYLIST_URL = /youtube\.com\/playlist\?/;
const PLAYLIST_ID = /[?&]list=([a-zA-Z0-9_-]+)/;
const SINGLE_VIDEO_ID = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))([\w-]{11})/;

export function getYouTubePlaylistEmbedUrl(url?: string) {
	if (!url || !PLAYLIST_URL.test(url) || SINGLE_VIDEO_ID.test(url)) {
		return "";
	}
	const playlistId = url.match(PLAYLIST_ID)?.[1];
	if (!playlistId) {
		return "";
	}
	return `https://www.youtube.com/embed/videoseries?list=${encodeURIComponent(playlistId)}&autoplay=1&mute=1&rel=0`;
}
